import BulkManageMobileDrawer from "common/components/BulkManageMobileDrawer";
import type { LinkedInProfile } from "common/types";

import {
  EXCLUDED_LIST_LEADS_ACTIONS,
  LIST_LEADS_ACTIONS,
} from "../../../constants";
import BlacklistLeads from "./ManageLeads/BlacklistLeads";
import RemoveExcludedLeads from "./ManageLeads/RemoveExcludedLeads";
import RemoveLeads from "./ManageLeads/RemoveLeads";
import UnblacklistLeads from "./ManageLeads/UnblacklistLeads";

import type { ListLead } from "../../../types";

//the exclusions-search returns plain profiles, the leads-search returns the
//list's own leads - the blacklist actions only apply to the latter
type ManageListLeadsProps =
  | { listId: string; isExcluded: true; selectedLeads: LinkedInProfile[] }
  | { listId: string; isExcluded: false; selectedLeads: ListLead[] };

export default function ManageListLeads({
  listId,
  isExcluded,
  selectedLeads,
}: ManageListLeadsProps) {
  //compared explicitly - with strictNullChecks off a truthiness check doesn't
  //narrow the union, so selectedLeads would stay widened
  if (isExcluded === true) {
    return (
      <BulkManageMobileDrawer
        drawerLabel="leads"
        actions={EXCLUDED_LIST_LEADS_ACTIONS}
        selection={selectedLeads}
        renderActionComponent={({ onBack, onClose }) => (
          <RemoveExcludedLeads
            listId={listId}
            selectedLeads={selectedLeads}
            onBack={onBack}
            onClose={onClose}
          />
        )}
      />
    );
  }

  return (
    <BulkManageMobileDrawer
      drawerLabel="leads"
      actions={LIST_LEADS_ACTIONS}
      selection={selectedLeads}
      renderActionComponent={({ action, onBack, onClose }) => {
        const props = {
          listId,
          selectedLeads,
          onBack,
          onClose,
        };

        if (action === "blacklist") {
          return <BlacklistLeads {...props} />;
        }
        if (action === "unblacklist") {
          return (
            <UnblacklistLeads
              selectedLeads={selectedLeads}
              onBack={onBack}
              onClose={onClose}
            />
          );
        }
        return <RemoveLeads {...props} />;
      }}
    />
  );
}
